import { userService } from "../api/user-auth";

const state = {
  customers: [],
  new_customer: null,
};

const getters = {
  // eslint-disable-next-line no-unused-vars
  customers: (state, getters) => {
    return state.customers;
  },
};

const actions = {
  loadCustomers({ commit }, customers) {
    commit("loadCustomers", customers);
  },
  getCustomers({ dispatch, commit }) {
    userService.getJson("customer/list").then(
      response => {
        if (response.ok) {
          commit("loadCustomers", response.data);
        } else {
          commit("clear");
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        commit("clear");
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiSaveCustomer({ dispatch, commit }, customer) {
    userService.put("customer/" + customer.id, customer).then(
      response => {
        if (response.ok) {
          commit("updateCustomer", response.data);
          dispatch("schedule/updateAvailableJobsOfCustomer", response.data, {
            root: true,
          });
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  apiCreateCustomer({ dispatch, commit }, customer) {
    userService.post("customer/" + customer.id, customer).then(
      response => {
        if (response.ok) {
          dispatch("plants/addPlant", response.data.plant, { root: true });
          dispatch("sites/addSite", response.data.site, { root: true });
          dispatch("sites/addPlant", response.data.plant, { root: true });
          dispatch("schedule/addAvailableJob", response.data.job, {
            root: true,
          });
          dispatch("jobs/addJob", response.data.job, { root: true });
          commit("addCustomer", response.data.customer);
          commit("addSite", response.data.site);
        } else {
          dispatch("alert/error", response.message, { root: true });
        }
      },
      error => {
        dispatch("alert/error", error, { root: true });
      },
    );
  },
  addSite({ commit }, site) {
    commit("addSite", site);
  },
};

const mutations = {
  addCustomer(state, customer) {
    state.customers.push(customer);
    state.customers.sort(function(a, b) {
      if (a.name.toLowerCase() == b.name.toLowerCase()) return 0;
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    });
    state.new_customer = customer;
  },
  updateCustomer(state, customer) {
    var index = state.customers.findIndex(v => v.id == customer.id);
    state.customers[index] = customer;
  },
  addSite(state, site) {
    var index = state.customers.findIndex(v => v.id == site.customer_id);
    state.customers[index].sites.push(site);
  },
  loadCustomers(state, customers) {
    customers.sort(function(a, b) {
      if (a.name.toLowerCase() == b.name.toLowerCase()) return 0;
      return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
    });
    state.customers = customers;
  },
  clear(state) {
    state.customers = [];
  },
};

export const customers = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
